const DEFAULT_POSITION = 'bottom left';
export default DEFAULT_POSITION;
export const positions = [
    'bottom left',
    'bottom center',
    'bottom right',
    'middle left',
    'middle center',
    'middle right',
    'top left',
    'top center',
    'top right',
];
//# sourceMappingURL=defaultPosition.js.map